module.exports = __webpack_public_path__ + "img/ardilla.0a6c7352.png";